import { render, staticRenderFns } from "./SystemDigest.vue?vue&type=template&id=7245a042&scoped=true"
import script from "./SystemDigest.vue?vue&type=script&lang=js"
export * from "./SystemDigest.vue?vue&type=script&lang=js"
import style0 from "./SystemDigest.vue?vue&type=style&index=0&id=7245a042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7245a042",
  null
  
)

export default component.exports